import { Checkbox, FormControlLabel } from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';


function Program(props) {
  const { pack, handlePackageChange, activeProgram } = props;
  const { currency: { symbol }, amount, details, id } = pack || {};
  const fee = details?.fee ? details.fee : 0;
  const labelValue = `${symbol} ${amount - fee}`;
  const isChecked = id === activeProgram.id;

  return (
    <FormControlLabel
      key={`gift-${id}`}
      className="root"
      control={
        <Checkbox
          checked={isChecked}
          value={id}
          onChange={handlePackageChange}
        />
      }
      label={labelValue}
    />
  );
}

export default Program;

Program.propTypes = {
  activeProgram: PropTypes.object.isRequired,
  handlePackageChange: PropTypes.func.isRequired,
  pack: PropTypes.object.isRequired,
};
